import React, { useState, useEffect } from 'react';
import '../../../App.css';
import Select, { components } from 'react-select';

import { collection, addDoc, getDocs, Timestamp, doc, updateDoc } from "firebase/firestore";
import { useLocation, useNavigate } from 'react-router-dom';
import { auth, db } from './../../../firebaseConfig';
import moment from 'moment';
import { getDaysInMonth } from 'date-fns';
function NewBookingCreationPage() {
  const navigate= useNavigate ();
    const location = useLocation();
  const [companies, setCompanies] = useState([]);
  const [talents, setTalents] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedTalent, setSelectedTalent] = useState(null);
  const dateFromURL = new URLSearchParams(location.search).get('date'); // "29.08.23"
  const formattedDate = moment(dateFromURL, "DD.MM.YY").format("YYYY-MM-DD"); // converts "29.08.23" to "2023-08-29"
  
  const [startDate, setStartDate] = useState(formattedDate);
  const [endDate, setEndDate] = useState('');
  const [status, setStatus] = useState('');
  const [bookingDetails, setBookingDetails] = useState(null);
  const [editingbokkingTalent, setEditingbookingTalent] = useState('');
  const [editingbokkingTalentid, setEditingbookingTalentid] = useState('');
  const [editingbookingCompany, setEditingbookingcompany] = useState('');
  const [loading, setLoading] = useState(true);
  
  const [skipCs, setSkipcs]=useState(false);
 
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState(new URLSearchParams(location.search).get('sonstige'));
  const [kpi, setKpi] = useState(new URLSearchParams(location.search).get('artikelanzahl'));
  const [set, setSet] = useState(new URLSearchParams(location.search).get('set'));
 // const [client, setClinet] = useState(new URLSearchParams(location.search).get('kunde'));
  const [segment, setSegment] = useState(new URLSearchParams(location.search).get('segment'));
  const [range, setRange] = useState(new URLSearchParams(location.search).get('range'));
  
  const [ends_on, setEnds_on] = useState('');
  const [period, setPeriod] = useState('');

  const [talent, setTalent] = useState("");
  const [talentId, setTalentId] = useState(' ');
  const [rate, setRate] = useState(' ');
  const [costumer, setCostumer] = useState(' ');
  const [selectSet, setSelectedSet]= useState('On Model')
  const companyNameurl = new URLSearchParams(location.search).get('kunde')
  const [bookingoption, setbookingoption] = useState();
  const [startTime, setStartTime]= useState();
  const [endTime, setEndTime]= useState();
  const [locations, setLocations] = useState([]);
  const [selectLocations, setSelectedLocations] = useState([]);
  const [sinfo, setSinfo] = useState('');

  const clients = [


    { value: 'PUMA', label: 'PUMA' },
    { value: 'Bogner', label: 'Bogner' },
    { value: 'TomTailor', label: 'Tom Tailor' },
    { value: 'Z-EPDP', label: 'Z-EPDP' },
    { value: 'HFG', label: 'HFG' },
    { value: 'Görtz', label: 'Görtz' },
    { value: 'ZEPS', label: 'ZEPS' },
    { value: 'ZRPDP', label: 'ZRPDP' },
    { value: 'BP', label: 'BP' },
  
  
    ];
    
  const initialClient = new URLSearchParams(location.search).get('kunde');
  const initialClientObject = clients.find(client => client.value === initialClient);
  const [companyNames, setCompanyNames] = useState([]);

  const fetchCompanyNames = async () => {
    const companySnap = await getDocs(collection(db, "SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/company"));  // Replace with the correct path
    const companyData = companySnap.docs.map(doc => doc.data().name);  // Assuming each document has a "name" field
    setCompanyNames(companyData);
  };
  const companyOptions = companyNames.map(company => ({
    value: company,
    label: company
})).sort((a, b) => a.label.localeCompare(b.label));
  const [client, setClient] = useState(initialClientObject);

  
  const options = [
    { value: 'new order', label: 'New order' },
    { value: 'optioned', label: 'Optioned' },
    { value: 'talentaccepted', label: 'Accepted by talent' },
    { value: 'confirmed', label: 'Confirmed' },
    { value: 'lano', label: 'Lano' }
  ];
  const position = [
    { value: 'HM', label: 'Hair & Make-Up' },
    { value: 'AD', label: 'Art Direktion' },
    { value: 'Foto', label: 'Foto' },
    { value: 'foto-assistent', label: 'Foto Assist' },
    { value: 'video', label: 'Video' },
    { value: 'digi-op', label: 'Digi-OP' },
    { value: 'styling', label: 'Styling' },
    { value: 'styling-assistent', label: 'Styling Assist' },
    { value: "LOGISTIK / WARENAUFBEREITUNG", label: "LOGISTIK / WARENAUFBEREITUNG" },
    { value: "PRODUCER", label: "PRODUCER" },
    { value: "Art Buying", label: "Art Buying" }, 
    { value: "Account Management", label: "Account Management" }, 

    


 
  ];
  const onmodel = [


    { value: 'onmodel', label: 'On Model' },
    { value: 'Produkt', label: 'On Produkt' },

  
  
    ];

  const bookingoptions = [


    { value: 'booking', label: 'Booking' },
    { value: 'option', label: 'Option' },

  
  
    ];

  const bookingId = new URLSearchParams(location.search).get('bookingId');
 // const kunde = new URLSearchParams(location.search).get('kunde');

  const customStyles = {
    dropdownIndicator: (provided, state) => ({
      ...provided,
      border: 'none',
    }),
    control: (base) => ({
      ...base,
      width: '400px',
      borderColor: 'black',
      borderWidth: '1px',
      boxShadow: 'none',
      margin: '5px',
      borderRadius: '0px',
      color: 'black',
      fontWeight: "700",
      height: '50px',
      textTransform: 'uppercase',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'black',
      fontWeight: "700"
    }),
    input: (provided) => ({
      ...provided,
      color: 'black',
      fontWeight: "700"
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'black' : 'inherit',
      '&:hover': { backgroundColor: state.isSelected ? 'black' : '#f7f7f7' }
    }),
  };

  const DropdownIndicator = props => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <div style={{ width: '16px', margin: '0' }}>
            <svg version="1.1" id="Isolationsmodus" x="0px" y="0px" viewBox="0 0 322.9 257.78" shapeRendering="geometricPrecision">
              <path xmlns="http://www.w3.org/2000/svg" d="M208.27,7.37c-4.69-4.79-11.12-7.4-17.72-7.81c-0.4-0.03-0.8-0.05-1.22-0.05l0,0h-35.34h-70.2H31.14h-4.27  C17.33-0.46,7.87,4.51,3.34,13.12C-1.19,21.65-1.3,32.3,4.19,40.47c0.85,1.3,1.74,2.56,2.6,3.82C17.3,59.73,27.77,75.2,38.27,90.64  c12.47,18.33,24.91,36.7,37.39,55.03c3.08,4.53,6.13,9.02,9.21,13.54c3.97,5.86,9.06,10.5,16.08,12.36  c6.87,1.86,14.85,0.93,20.9-2.93c3.79-2.45,6.24-5.12,8.8-8.79c8.06-11.54,15.82-23.3,23.76-34.96  c13.14-19.33,26.25-38.67,39.39-57.96c4.68-6.87,9.32-13.73,14-20.63c4.31-6.31,8.39-12.13,8.2-20.41  C215.85,18.95,213.1,12.34,208.27,7.37z" />
            </svg>
          </div>
        </components.DropdownIndicator>
      )
    );
  };


  const [selectedOption, setSelectedOption] = React.useState("new order");
  const [selectedPosition, setselectedPosition] = React.useState(null);
  const handleOptionChange = selectedOption => {

    setSelectedOption(selectedOption);
  }

  const handlebookingOption = selectedOption => {

    setbookingoption(selectedOption);
  }


  const handlePostionchange = selectedPosition => {

    setselectedPosition(selectedPosition);
  }

  const handleClientChange = selectedOption => {

    setClient(selectedOption);
  }


  const [clientValid, setClientValid] = useState(true);
  const [positionValid, setPositionValid] = useState(true);
  const [optionsValid, setOptionsValid] = useState(true);


  useEffect(() => {
    // Fetch companies and talents
    fetchCompanyNames();
    const fetchCompaniesAndTalents = async () => {
      const companySnap = await getDocs(collection(db, "SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/company"));
      const talentSnap = await getDocs(collection(db, "SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/talents"));

      const companyData = companySnap.docs.map(doc => ({
        value: doc.id,
        label: doc.data().name  // assumes the company document has a 'name' field
      }));
      const talentData = talentSnap.docs.map(doc => ({
        value: doc.id,
        label: doc.data().name,  // assumes the talent document has a 'name' field
        email: doc.data().email
      }));

      if (companyNameurl) {
        const matchingCompany = companyData.find(company => company.label === companyNameurl);
        setSelectedCompany(matchingCompany);
    }

      setCompanies(companyData);
      setTalents(talentData);

      // If bookingId is present, fetch the booking details
      // If bookingId is present, fetch the booking details
    


      setLoading(false);
    };

    fetchCompaniesAndTalents();
  }, []);




  const handleCompanyChange = (selectedOption) => {
    setSelectedCompany(selectedOption);
  };

  const handlesetSelect = (selectedOption) => {
    setSet(selectedOption);
  };

  const handleTalentChange = (selectedOption) => {
    setSelectedTalent(selectedOption);
  };
  const createmail = async ( newValue) => {
    const msg = {
      to: 'booking@set-cast.com, talent@mondula.com, ' +localStorage.getItem("userEmail") ,
      message: {
        subject: 'A new Orderhas been Requested ',
        text: `A new Orderhas been Requested `,
        html: `
       
        
        
            <p>A new Orderhas been Requested.</p>
          
            <p>  Title:  ${newValue.title} </p>
            <p>  StartDate:  ${newValue.startDate} </p>
            <p>  End Date:  ${newValue.endDate} </p>
            <p>  Position:  ${newValue.position.label} </p>
            <p>  Client:  ${newValue.client.label} </p>
            <p>  KPI:  ${newValue.kpi} </p>
            <p>  SET:  ${newValue.set} </p>
        

   
            <p> 
            Propose talents to this:
           <a href=" https://app.set-cast.com/admin/propose?bookingId=${newValue.bookingID}"> https://app.set-cast.com/admin/propose?bookingId=${newValue.bookingID} </a>
            </p>
            <p> 
            Manage All new Orders:
            <a href="https://app.set-cast.com/admin/allnewbookings">  https://app.set-cast.com/admin/allnewbookings </a>
            
            </p>`,
      },
    };
    console.log(msg);

    await addDoc(collection(db, "/SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/mail"), msg);
  };


  
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!client) {
      setClientValid(false);
      return; // Exit the function
    } else {
      setClientValid(true);
    }
  
    if (!selectedPosition) {
      setPositionValid(false);
      return; // Exit the function
    } else {
      setPositionValid(true);
    }

    if (!bookingoption) {
      setOptionsValid(false);
      return; // Exit the function
    } else {
      setOptionsValid(true);
    }

    // Check if it's a new booking or an update
    if (bookingId) {
      // Update existing booking
      try {
        const bookingRef = doc(db, "SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/Bookings", bookingId);

          await updateDoc(bookingRef, {
            start_date: Timestamp.fromDate(new Date(startDate)),
            end_date: Timestamp.fromDate(new Date(startDate)),
            status: selectedOption,
            title:title,
            location:title,
            kpi:kpi,
            set:set,
            position:selectedPosition ,
            client: client,
            sinfo:sinfo,
            costcenter1: ' ',
            costcenter2: ' ',
            option: bookingoption.value,
            studio:description,
            createdBy: localStorage.getItem("userEmail"),

          });
  
          alert("Booking updated successfully.");
         
          navigate('allbooking');
        
      } catch (error) {
        console.error("Error updating booking: ", error);
      }
    } else {
      try {
       
          const newBookingStartDate = new Date(startDate);
          const newBookingEndDate = new Date(endDate);
          const currentDateTime = new Date(); 

          for (let dt = new Date(newBookingStartDate); dt <= newBookingEndDate; dt.setDate(dt.getDate() + 1)) {
            const singleDayDate = new Date(dt);
      
          const newBooking = {
          //  companyID: `/company/AmkMAPHQL4TFA9BNicw3`,
  
            start_date:  Timestamp.fromDate(singleDayDate),
            end_date:  Timestamp.fromDate(singleDayDate),
            status: selectedOption,
            title:title,
            kpi:kpi,
            set:set.label,
            position:selectedPosition ,
            client: client,
            sinfo:sinfo,
            studio:description,
            costcenter1: ' ',
            costcenter2: ' ',
          //  option: bookingoption.value,
            createdBy: localStorage.getItem("userEmail"),
            proposedBy:'',
            createdAt: Timestamp.fromDate(currentDateTime),
            startTime: startTime,
            endTime:endTime,
            location:selectLocations.value,

          };
        
         const docRef = await addDoc(collection(db, "SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/Bookings"), newBooking);
      
          const newValue = {
           // company: selectedCompany.label,
           // talentId: selectedTalent.label,
            startDate: newBookingStartDate,
            endDate: newBookingStartDate,
            status: newBooking.status,
            title:title,
            kpi:kpi,
            set:set.label,
            position:selectedPosition,
            client: client,
            segment: segment,
            range: range,
            costcenter1: ' ',
            costcenter2: ' ',
        //   option: bookingoption.value,
           bookingID: docRef.id,
           createdBy: localStorage.getItem("userEmail"),
           startTime: startTime,
           endTime:endTime,
           location:selectLocations.value,
           sinfo:sinfo,

         //   skipconfirm: skip
         //   skipconfirm: skipCs,

          };
        }
        alert("Booking added successfully.");
      //    await createmail( newValue);
          navigate('allbooking');
        
    
        
          // Pass the selected talent's email and the new booking value to your sendmail function
       
        
        
      } catch (e) {
        console.error("Error adding booking: ", e);
      }
    }
  };
  const fetchlocations = async () => {
    const locationSnap = await getDocs(collection(db, "SetCast CTA GmbH/bIETrNIclVpe0eINr1Z1/locations"));  
    const locationData = locationSnap.docs.map(doc => doc.data().short); 
    setLocations(locationData);
  };
  const locationOptions = locations.map(locations => ({
    value: locations,
    label: locations
  })).sort((a, b) => a.label.localeCompare(b.label));
  

  useEffect(() => {
    fetchlocations();
    if (startDate === "") {
      document.getElementById("start-date").placeholder = "Start Date";
    }

  
  }, [startDate, endDate]);
console.log(companyNameurl);
  return (
    <div class="content-wrapper">
      <section>
        <h1 className='h1'>{bookingId ? 'Update Booking' : 'Create Order'}</h1>
        <form onSubmit={handleSubmit}
          style={{
            marginTop: '40px',
            maxWidth: '500px'
          }}
        >
          {bookingId ? (

            // If bookingId exists, render your 'editing' JSX here, example:
            <div style={{ width: '100%', textTransform: 'uppercase' }} >

            </div>
          ) : (
            <>
            
              </>
          )}

            <Select
                components={{ DropdownIndicator }}
                options={companyOptions}
                onChange={handleClientChange}
                placeholder="Client"
                value={client}
                styles={customStyles}
              />
              {!clientValid && <p className="error-message">Client is required.</p>}

            <Select
            components={{ DropdownIndicator }}
            options={position}
            onChange={handlePostionchange}
            placeholder="Position"
            value={selectedPosition}
            styles={customStyles}
            />
    {!positionValid && <p className="error-message">Position is required.</p>}
    <input className='inputtext' type="text" value={description} onChange={(e) => setDescription(e.target.value)} required placeholder='Studio'/>

        
    <Select
                  
                      value={selectLocations}
                      onChange={setSelectedLocations}
                      options={locationOptions}
                      isClearable
                      placeholder="Locations"
                      styles={customStyles}
                    />
            <input className='inputtext' type="text" value={kpi} onChange={(e) => setKpi(e.target.value)} required placeholder='KPI'/>

   
            <Select
            components={{ DropdownIndicator }}
            options={onmodel}
            onChange={handlesetSelect}
            placeholder="Set"
            value={set}
            styles={customStyles}
            />
            <input className='inputtext' type="text" value={sinfo} onChange={(e) => setSinfo(e.target.value)}  placeholder='S. Info'/>

            <input className='inputtext' type="text" value={startTime} onChange={(e) => setStartTime(e.target.value)} required placeholder='Start Time'/>
            <input className='inputtext' type="text" value={endTime} onChange={(e) => setEndTime(e.target.value)} required placeholder='End Time'/>
        

          <div style={{ display: 'flex' }}>
            <div className="date-input-wrapper" >
              <input className='inputdate'   id="start-date" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} required />
              <svg className="custom-icon" viewBox="0 0 500 500" >
                <path d="M477.5,39h-105V21.5c0-6.25-3.34-12.03-8.75-15.16s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-70V21.5  c0-6.25-3.34-12.03-8.75-15.16s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-70V21.5c0-6.25-3.34-12.03-8.75-15.16  s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-105c-4.64,0-9.09,1.84-12.38,5.12S5,51.86,5,56.5v420c0,4.64,1.84,9.09,5.12,12.38  S17.86,494,22.5,494h455c4.64,0,9.09-1.84,12.38-5.12s5.12-7.73,5.12-12.38v-420c0-4.64-1.84-9.09-5.12-12.38S482.14,39,477.5,39z   M127.5,74v17.5c0,6.25,3.34,12.03,8.75,15.16s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74h70v17.5c0,6.25,3.34,12.03,8.75,15.16  s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74h70v17.5c0,6.25,3.34,12.03,8.75,15.16s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74H460v70  H40V74H127.5z M40,459V179h420v280H40z M302.5,249c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70  c-6.25,0-12.03-3.34-15.16-8.75c-3.12-5.41-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S302.5,244.36,302.5,249z M425,249c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  c-3.12-5.41-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S425,244.36,425,249z M180,249  c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75c-3.12-5.41-3.12-12.09,0-17.5  s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S180,244.36,180,249z M302.5,319c0,4.64-1.84,9.09-5.12,12.38  s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S302.5,314.36,302.5,319z M425,319c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S425,314.36,425,319z M180,319c0,4.64-1.84,9.09-5.12,12.38  s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S180,314.36,180,319z M302.5,389c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S302.5,384.36,302.5,389z M425,389  c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70  c4.64,0,9.09,1.84,12.38,5.12S425,384.36,425,389z M180,389c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70  c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S180,384.36,180,389z" />
              </svg>
            </div>
          

            <div className="date-input-wrapper">
              <input className='inputdate' id="end-date" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} required placeholder='END' />
              <svg className="custom-icon" viewBox="0 0 500 500" >
                <path d="M477.5,39h-105V21.5c0-6.25-3.34-12.03-8.75-15.16s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-70V21.5  c0-6.25-3.34-12.03-8.75-15.16s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-70V21.5c0-6.25-3.34-12.03-8.75-15.16  s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-105c-4.64,0-9.09,1.84-12.38,5.12S5,51.86,5,56.5v420c0,4.64,1.84,9.09,5.12,12.38  S17.86,494,22.5,494h455c4.64,0,9.09-1.84,12.38-5.12s5.12-7.73,5.12-12.38v-420c0-4.64-1.84-9.09-5.12-12.38S482.14,39,477.5,39z   M127.5,74v17.5c0,6.25,3.34,12.03,8.75,15.16s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74h70v17.5c0,6.25,3.34,12.03,8.75,15.16  s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74h70v17.5c0,6.25,3.34,12.03,8.75,15.16s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74H460v70  H40V74H127.5z M40,459V179h420v280H40z M302.5,249c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70  c-6.25,0-12.03-3.34-15.16-8.75c-3.12-5.41-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S302.5,244.36,302.5,249z M425,249c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  c-3.12-5.41-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S425,244.36,425,249z M180,249  c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75c-3.12-5.41-3.12-12.09,0-17.5  s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S180,244.36,180,249z M302.5,319c0,4.64-1.84,9.09-5.12,12.38  s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S302.5,314.36,302.5,319z M425,319c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S425,314.36,425,319z M180,319c0,4.64-1.84,9.09-5.12,12.38  s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S180,314.36,180,319z M302.5,389c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S302.5,384.36,302.5,389z M425,389  c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70  c4.64,0,9.09,1.84,12.38,5.12S425,384.36,425,389z M180,389c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70  c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S180,384.36,180,389z" />
              </svg>
            </div>
    
         
          </div>

      
        <Select
                components={{ DropdownIndicator }}
                options={bookingoptions}
                onChange={handlebookingOption}
                placeholder="Option"
                value={bookingoption}
                styles={customStyles}
                />
    
    {!optionsValid && <p className="error-message">Option is required.</p>} 

            <button style={{ marginTop: '20px' }} className='big-button' type="submit">{bookingId ? 'Update Booking' : 'Create Order'}</button>
        </form>
      </section>
    </div>
  );
}

export default NewBookingCreationPage;
